// extracted by mini-css-extract-plugin
export default {"stepColumns":"home-sections-header-tabs_stepColumns__zSw6D"};